import { render } from "./SelectSizeM.vue?vue&type=template&id=565ae9a4"
import script from "./SelectSizeM.vue?vue&type=script&lang=js"
export * from "./SelectSizeM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v3/SelectSizeM.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "565ae9a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('565ae9a4', __exports__)) {
    api.reload('565ae9a4', __exports__)
  }
  
  module.hot.accept("./SelectSizeM.vue?vue&type=template&id=565ae9a4", () => {
    api.rerender('565ae9a4', render)
  })

}


export default __exports__